import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
interface DiaryEntryProps {
  date: string;
  title: string;
  content: React.ReactNode;
  entryNumber: number;
}
export function DiaryEntry({
  date,
  title,
  content,
  entryNumber
}: DiaryEntryProps) {
  // Alternate slight rotation for a more organic, scattered diary feel
  const rotation = entryNumber % 2 === 0 ? 'md:rotate-1' : 'md:-rotate-1';
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay: 0.1
  }} className={`relative w-full max-w-2xl mx-auto mb-12 ${rotation} transition-transform duration-300 hover:rotate-0`} data-id="element-35">
      {/* Decorative tape piece */}
      <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-24 h-6 bg-white/40 backdrop-blur-sm border border-white/20 shadow-sm rotate-2 z-10" data-id="element-36"></div>

      <div className="paper-texture rounded-sm p-6 md:p-10 shadow-md border border-warmBrown/10 relative overflow-hidden" data-id="element-37">
        {/* Subtle lines background to look like a notebook */}
        <div className="absolute inset-0 pointer-events-none" style={{
        backgroundImage: 'linear-gradient(transparent 95%, rgba(139, 69, 19, 0.05) 100%)',
        backgroundSize: '100% 2rem'
      }} data-id="element-38"></div>

        <div className="relative z-10" data-id="element-39">
          <div className="flex items-center gap-2 text-warmBrown/60 mb-4 font-handwritten text-xl" data-id="element-40">
            <Calendar size={18} data-id="element-41" />
            <span data-id="element-42">{date}</span>
          </div>

          <h3 className="font-handwritten text-3xl md:text-4xl text-forestGreen font-bold mb-4" data-id="element-43">
            Eintrag {entryNumber}: {title}
          </h3>

          <p className="font-serif text-base md:text-lg text-gray-800 leading-loose" data-id="element-44">
            {content}
          </p>
        </div>
      </div>
    </motion.div>;
}